import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  public href: string = "";
  url: string = "asdf";
  title = 'my-teksun';

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.href = this.router.url;
  }
}
